import CryptoJS from 'crypto-js';

// Generate a random encryption key
export const generateEncryptionKey = () => {
  return CryptoJS.lib.WordArray.random(32).toString();
};

// Encrypt a message
export const encryptMessage = (message, secretKey) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(message, secretKey).toString();
    return encrypted;
  } catch (error) {
    console.error('Encryption error:', error);
    return message;
  }
};

// Decrypt a message
export const decryptMessage = (encryptedMessage, secretKey) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedMessage, secretKey);
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
    return encryptedMessage;
  }
};

// Generate gibberish text for deceptive purposes
export const generateGibberish = (length = 50) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Check if text is encrypted (looks like gibberish)
export const isEncrypted = (text) => {
  // Simple heuristic: if text contains many special characters and numbers, it's likely encrypted
  const specialCharRatio = (text.match(/[!@#$%^&*()_+\-=\[\]{}|;:,.<>?0-9]/g) || []).length / text.length;
  return specialCharRatio > 0.3;
};
